import RookeryBold from 'assets/fonts/Rookery-Bold.woff2';
import { default as RookeryRegular } from 'assets/fonts/Rookery-Regular.woff2';

import { ptBR } from '@mui/material/locale';
import { alpha, createTheme } from '@mui/material/styles';

export const globalStyle = {
  typography: {
    fontFamily: 'Rookery-Regular, Rookery-Bold',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': {
          fontFamily: 'Rookery-Bold',
          src: `local('Rookery-Bold'), url(${RookeryBold}) format('woff2')`,
        },
      },
      fallbacks: [
        {
          '@font-face': {
            fontFamily: 'Rookery-Regular',
            fontWeight: 400,
            src: `local('Rookery-Regular'), url(${RookeryRegular}) format('woff2')`,
          },
        },
      ],
    },
  },
};

export const theme = createTheme(
  {
    breakpoints: {
      values: {
        xs: 0,
        ms: 300,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    palette: {
      common: {
        white: '#ffffff',
        black: '#000000',
      },
      background: {
        default: '#00000099',
      },
      primary: {
        light: '#244B63',
        main: '#1F3F5E',
        dark: '#0F2D4A',
        contrastText: '#FCFBFB',
        50: '#072140',
        100: '#001429',
        800: `linear-gradient(135deg, #031E3A, #1F3F5E)`,
      },
      secondary: {
        light: '#BAC9D6',
        main: '#9BAEBC',
        dark: '#7B92A6',
        contrastText: '#001E2E',
      },
      info: {
        light: '#FFFFFF',
        main: '#FBFBFB',
        dark: '#F0F0F0',
        contrastText: '#001E2E',
      },
      details: {
        light: '#C3E7FF',
        main: '#90C0EB',
        dark: '#2B9ACE',
        contrastText: '#001E2E',
      },
      tertiary: {
        light: '#FF6E67',
        main: '#ff554d',
        dark: '#D94841',
        contrastText: '#FCFBFB',
      },
      green: {
        light: '#77F8DE',
        main: '#58DBC3',
        dark: '#33BFA7',
        contrastText: '#FCFBFB',
      },
      orange: {
        light: '#FFB685',
        main: '#FF8D34',
        dark: '#E07318',
        contrastText: '#FCFBFB',
      },
      warning: {
        main: '#ffb684',
        light: '#B9BAFF',
      },
      error: {
        light: '#EC928E',
        main: '#E46962',
        dark: '#DC362E',
      },
      blue: {
        light: '#E3F3FF',
        dark: '#001D38',
        main: '#007EAF',
        contrastText: '#FFFFFF',
      },
      gradient: {
        100: `linear-gradient(45deg, #FF554D, #FFBA8F)`,
        200: `linear-gradient(#001429,#001429)`,
        300: `linear-gradient(90deg, transparent 0%, ${alpha('#072140', 0.7)} 20%, #072140 40%)`,
        400: `linear-gradient(-90deg, transparent 0%, ${alpha('#072140', 0.7)} 30%, #072140 50%)`,
        500: `linear-gradient(#1F3F5E,#1F3F5E)`,
        600: `linear-gradient(45deg, #062341,#031B35)`,
        700: `linear-gradient(#0F2D4A,#0F2D4A)`,
        800: `linear-gradient(#244B63, #244B63)`,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          '*': {
            scrollbarColor: '#FF6E67 #0F2D4A',
            scrollbarWidth: 'thin',
            '&::-webkit-scrollbar': {
              width: '0.5rem',
              backgroundColor: '#0F2D4A',
            },
            '.medium-zoom-overlay, .medium-zoom-image--opened': {
              zIndex: '999',
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '0.5rem',
              backgroundColor: '#E46962',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#FFBA8F',
            },
            '.caf-web-sdk .caf-sdk-upload-container .caf-sdk-upload-overlay ': {
              background: `#0F2D4A !important`,
              color: '#000000 !important',
            },
            '.caf-sdk-message-container .caf-sdk-message-sub-text .caf-sdk-message-text': {
              color: '#000000 !important',
            },
            '.pointer': {
              cursor: 'pointer',
            },
            '.empty-line:empty::before': {
              content: "'-'",
            },

            WebkitTapHighlightColor: 'transparent',
          },
          html: {
            scrollBehavior: 'smooth',
          },
          body: {
            background: `linear-gradient(135deg, #031E3A, #1F3F5E)`,
          },
          input: {
            autofill: {
              border: '3px solid darkorange',
            },
            WebkitAutofill: {
              border: '3px solid darkorange',
            },
          },
        },
      },
    },
  },
  ptBR,
);
